import React, { useContext, useState } from "react";
import ListaUsuarios from "./ListaUsuarios";
import { Upload, Plus } from "lucide-react";
import "./NewUserModal.css";
import "./UsuariosAdmin.css";
import ImportarUsuarios from "./ImportarUsuarios";
import Permiso from "../../router/Permiso";
import NewUserModal from "./NewUserModal";
import { AuthContext } from "../../context/AuthContext";

const UsuariosAdmin = () => {
  const { token } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState("lista");
  const [showNewUserModal, setShowNewUserModal] = useState(false);
  const [modalMode, setModalMode] = useState("nuevo"); 
  const [selectedUser, setSelectedUser] = useState(null);
  const [refreshList, setRefreshList] = useState(false);
  const [mostrarImportar, setMostrarImportar] = useState(false);
  const [debeRecargar, setDebeRecargar] = useState(false);

  const handleOpenNewUser = () => {
    setModalMode("nuevo");
    setSelectedUser(null);
    setShowNewUserModal(true);
  };

  const handleConsultarUsuario = (usuario) => {
    setModalMode("consulta");
    setSelectedUser(usuario);
    setShowNewUserModal(true);
  };

  const handleSaveUser = (newUser) => {
    setShowNewUserModal(false);
    setDebeRecargar(true);
    setRefreshList((prev) => !prev);
  };

  return (
    <div className="usuarios-admin-outer">
      <div className="usuarios-admin-header">
        <div className="usuarios-admin-header-row">
          <div>
            <div className="usuarios-admin-title">Usuarios</div>
            <div className="usuarios-admin-subtitle">
              Gestión profesional de usuarios
            </div>
          </div>
          {activeTab === "lista" && (
            <div className="usuarios-admin-actions">
              <Permiso permiso="create_user">
                <button
                  className="btn-nuevo-usuario"
                  onClick={handleOpenNewUser}
                >
                  <Plus size={18} style={{ marginRight: "6px" }} /> Nuevo
                </button>
              </Permiso>
              <Permiso permiso="import_users">
                <button
                  className="btn-nuevo-importar"
                  onClick={() => setMostrarImportar(true)}
                >
                  <Upload size={18} style={{ marginRight: "6px" }} />
                  Importar
                </button>
                {mostrarImportar && (
                  <ImportarUsuarios
                    onClose={() => setMostrarImportar(false)}
                    onSuccess={() => setDebeRecargar(true)}
                    token={token}
                  />
                )}
              </Permiso>
            </div>
          )}
        </div>
        <div className="usuarios-admin-tabs">
          <button
            className={activeTab === "lista" ? "active" : ""}
            onClick={() => setActiveTab("lista")}
          >
            Lista de usuarios
          </button>
        </div>
      </div>
      <div className="usuarios-admin-tab-content">
        {activeTab === "lista" && (
          <ListaUsuarios
            token={token}
            onConsultar={handleConsultarUsuario}
            debeRecargar={debeRecargar}
            onRecargaCompleta={() => setDebeRecargar(false)}
            refreshTrigger={refreshList}
          />
        )}
       
      </div>
      <NewUserModal
        open={showNewUserModal}
        onClose={() => setShowNewUserModal(false)}
        onSave={handleSaveUser}
        initialData={modalMode === "consulta" ? selectedUser : {}}
        readOnly={modalMode === "consulta"}
        token={token}
      />
    </div>
  );
};

export default UsuariosAdmin;
